import { render, staticRenderFns } from "./fpzLiabilityCommon.vue?vue&type=template&id=cead58e8&scoped=true"
import script from "./fpzLiabilityCommon.vue?vue&type=script&lang=js"
export * from "./fpzLiabilityCommon.vue?vue&type=script&lang=js"
import style0 from "./fpzLiabilityCommon.vue?vue&type=style&index=0&id=cead58e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cead58e8",
  null
  
)

export default component.exports